<template>
	<n-tag :round :color="{ color: 'transparent' }" :size class="text-fs-sm font-normal">
		<template v-if="icon" #icon>
			<Icon :name="icon" :size="sizePX" />
		</template>
		{{ label }}
	</n-tag>
</template>

<script setup lang="ts">
import type { I18nString } from "@/lang/config"
import type { PatientMeta } from "@/types/patient"
import { NTag } from "naive-ui"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"

const { meta, size } = defineProps<{
	meta: PatientMeta
	round?: boolean
	size?: "small" | "medium" | "large" | "tiny"
}>()

const { t } = useI18n()

const sizePX = computed(() => (size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : 14))

const label = computed(() =>
	meta.singleton ? t<I18nString>(`patients.tags.not_twin_birth`) : t<I18nString>(`patients.tags.twin_birth`)
)

const icon = computed(() => ICONS.twins)
</script>
